<template>
  <div id="page-product-form">
    <vs-row>
      <vs-col>
        <card-page card-title="Products">
          <vue-element-loading :active="busy"></vue-element-loading>
          <div :class="[
                'form-wrapper',
                showForm ? '' : 'empty-wrapper'
              ]"
          >
            <div class="flex justify-center m-4" v-if="!showForm">
              <p>No Products have been added</p>
            </div>
            <vue-form-generator
                v-else
                class="mt-4 readonly-form facilities crud-additive-form bordered-buttons"
                ref="additiveForm"
                :model="value"
                :options="formOptions"
                :schema="schema"
            />
            <div :class="[
                'flex add-button-wrapper',
                showForm ? 'justify-end' : 'justify-center'
              ]"
            >
              <vs-button
                  class="mx-4 mb-4 add-button"
                  v-if="true || componentAccess.canCreate.access"
                  @click="goToCreate"
              >
                Add
              </vs-button>
            </div>
          </div>
        </card-page>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>

import FormModelMixin from '@/components/mixins/FormModelMixin';
import { selectOptions, arrayOptions } from '@/components/form/FormElementOption';
import AdditiveWidget from '@/components/form/fields/AdditiveWidget';
import CardPage from '../../../../components/Views/CardPage';
import CanAccessMixin from '@/components/mixins/CanAccessMixin';

export default {
  name: 'SectionRiskCodesAdditiveForm',
  props: {
    value: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  components: {
    AdditiveWidget,
    CardPage,
  },
  mixins: [FormModelMixin, CanAccessMixin],
  data() {
    return {
      componentAccess: {
        canDelete: {
          route: 'facilities.sections.product.delete',
          access: false,
        },
        canCreate: {
          route: 'facilities.sections.product.create',
          access: false,
        },
      },
      additiveForms: [
        'formRiskCode',
      ],
      model: {
        risk_codes: [],
      },
      schema: {
        groups: [
          {
            styleClasses: 'text-black w-full',
            fields: [
              {
                model: 'products',
                ...arrayOptions,
                hideAddButton: true,
                showRemoveButton: false,
                items: {
                  type: 'object',
                  schema: {
                    groups: [
                      {
                        styleClasses: 'w-11/12 content',
                        fields: [
                          {
                            disabled: true,
                            type: 'vueMultiSelect',
                            inputType: 'text',
                            styleClasses: 'w-1/3',
                            label: 'Product',
                            model: 'Product_FK',
                            values: () => this.products,
                            selectOptions,
                          },
                          {
                            disabled: true,
                            type: 'vueMultiSelect',
                            inputType: 'text',
                            styleClasses: 'w-1/3',
                            label: 'Print Issue system',
                            model: 'PrintIssueSystem_FK',
                            values: () => this.printIssueSystem,
                            selectOptions,
                          },
                          {
                            disabled: true,
                            type: 'vueMultiSelect',
                            inputType: 'text',
                            styleClasses: 'w-1/3',
                            label: 'Print Issue Method',
                            model: 'PrintIssueMethod_FK',
                            values: () => this.printIssueMethod,
                            selectOptions,
                          },
                        ]
                      },
                      {
                        styleClasses:
                            'w-1/12 tobas crud-buttons flex',
                        fields: [
                          {
                            type: 'awesomeButton',
                            styleClasses: 'awesome-form-button edit',
                            buttonOptions: {
                              route: {
                                name: 'facilities.sections.products.edit',
                                routeParam: 'productId',
                              },
                              icon: {
                                prefix: 'fal',
                                iconName: 'pencil'
                              },
                            },
                          },
                          {
                            type: 'awesomeButton',
                            styleClasses: 'awesome-form-button delete',
                            buttonOptions: {
                              icon: {
                                prefix: 'fal',
                                iconName: 'times'
                              },
                            },
                            onClick: async (model) => {
                              this.$emit(
                                  'deleteProduct',
                                  model.id
                              )
                            }
                          }
                        ]
                      }]
                  }
                }
              },
            ]
          },
        ],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
      products: [],
      printIssueSystem: [],
      printIssueMethod: [],
      options: [
        {
          endpoint: () => this.$api.products.list({ params: { all: true, includeOwner: true } }),
          optionsFieldName: 'products',
          nameFieldName: 'ProductCode',
          idFieldName: 'Product_FK',
          modelArrayName: 'products',
        },
        {
          endpoint: () => this.$api.facilities.sections.printIssueSystem.list(),
          optionsFieldName: 'printIssueSystem',
          nameFieldName: 'TypeName',
          idFieldName: 'PrintIssueSystem_FK',
          modelArrayName: 'products',
        },
        {
          endpoint: () => this.$api.facilities.sections.printIssueMethod.list(),
          optionsFieldName: 'printIssueMethod',
          nameFieldName: 'TypeName',
          idFieldName: 'PrintIssueMethod_FK',
          modelArrayName: 'products',
        },
      ],
    };
  },
  computed: {
    showForm() {
      return this.value.products
          ? this.value.products.length
          : false;
    },
    showRemoveButton() {
      return true; // FOR TESTING

      return this.componentAccess.canDelete.access;
    }
  },
  methods: {
    goToCreate() {
      this.$router.push({ name: 'facilities.sections.products.create' })
    },
  },
};
</script>
